import { render, staticRenderFns } from "./ArtistText.vue?vue&type=template&id=29c9403d"
import script from "./ArtistText.vue?vue&type=script&lang=js"
export * from "./ArtistText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports